import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootReducersState } from 'redux/reducers';
import commonService from 'utils/commonService';
import List from './List';
import Table from './Table';
import MergeTable from './MergeTable';
import { IProps, IChildElement } from './types';

const InsuredContent: React.FC<IProps> & IChildElement = (props) => {
  const [detailOpen, setDetailOpen] = useState(true);
  const resources = useSelector((state: RootReducersState) => state.resources);

  const handleDetailToggle = () => {
    setDetailOpen(!detailOpen);
  };

  return (
    <div className="insured-content">
      <div className="insured-content__title">
        <span>{commonService.getNameByLng(resources, 'TID_Insurance_content')}</span>
        {props.collapsible && (
          <button
            type="button"
            className={'element__icon-button' + (detailOpen ? ' element__icon-button--close' : ' element__icon-button--add')}
            onClick={handleDetailToggle}
          >
            {detailOpen ? commonService.getNameByLng(resources, 'TID_Collapse') : commonService.getNameByLng(resources, 'TID_Expand')}
          </button>
        )}
      </div>
      <div className="insured-content__content">
        {React.Children.map(
          props.children,
          child => React.cloneElement(child as React.ReactElement<any>, {
            detailOpen: detailOpen
          })
        )}
      </div>
    </div>
  );
};

InsuredContent.defaultProps = {
  collapsible: false
};

InsuredContent.List = List;
InsuredContent.Table = Table;
InsuredContent.MergeTable = MergeTable;

export default InsuredContent;
